import axios from 'axios';
import store from 'store';
import cookies from 'js-cookie';

const token = store.get('token');

let bearerToken;
if (token !== null) {
	bearerToken = `Bearer ${token}`;
}


export default axios.create({
	baseURL: process.env.REACT_APP_API_URL,
	headers: {
		authorization: bearerToken,
		'Access-Control-Allow-Origin': '*',
		contentType: 'aplication/json',
		accept: 'application/json',
		"Accept-Language": cookies.get('i18next')
	},
});
